import { render, staticRenderFns } from "./ImageFullscreenPreview.vue?vue&type=template&id=1dc2b9b0&scoped=true&"
import script from "./ImageFullscreenPreview.vue?vue&type=script&lang=js&"
export * from "./ImageFullscreenPreview.vue?vue&type=script&lang=js&"
import style0 from "./ImageFullscreenPreview.vue?vue&type=style&index=0&id=1dc2b9b0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc2b9b0",
  null
  
)

export default component.exports